export const ruffTimeView = () => ({
  type: 'Views loading error page',
});

export const userViewsLoadingScreen = eventVariationId => ({
  type: `User views Crunching Numbers page`,
  data: {
    ...(eventVariationId && {
      variation_name: 'test',
      variation_id: eventVariationId,
    }),
  },
});
